import React, { useState } from "react";
import { useDispatch } from "react-redux";

//material-ui
import makeStyles from "@material-ui/core/styles/makeStyles";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";

import SyncIcon from "@material-ui/icons/Sync";

//local
import ScheduledTaskHistory from "./ScheduledTaskHistory";
import ScheduledTaskRealtime from "./ScheduledTaskRealtime";
import { IconButton } from "@material-ui/core";
import { REFRESH_TASK } from "../../reducers/scheduledTaskReducer";

const tabs = ["Realtime", "History"];

const choicesPeriod = [
  { id: `1-weeks`, name: "1 Week" },
  { id: `1-months`, name: "1 Month" },
  { id: "3-months", name: "3 Months" }
];

const useStyles = makeStyles(theme => ({
  content: {
    margin: "1.5em"
  },
  rootHeader: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between"
  },
  headerContainer: {
    marginLeft: "1.5em"
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200
  },
  menu: {
    width: 200
  }
}));

const ScheduledTask = () => {
  const classes = useStyles();

  //state
  const [tabIdx, setTabIdx] = useState(0); // 0 - Realtime, 1 - History
  const [period, setPeriod] = useState("1-weeks"); // Applicable only when tab is 'history'

  const dispatch = useDispatch();

  const onRefresh = () => {
    dispatch({ type: REFRESH_TASK });
  };

  return (
    <div>
      {/** Header */}
      <div className={classes.rootHeader}>
        <div className={classes.headerContainer}>
          <Tabs value={tabIdx} onChange={(_, value) => setTabIdx(value)}>
            {tabs.map((tab, idx) => (
              <Tab key={idx} label={tab} />
            ))}
          </Tabs>
        </div>
        <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
          {tabIdx === 0 && (
            <div style={{ marginRight: "1.5em" }}>
              <IconButton onClick={onRefresh}>
                <SyncIcon />
              </IconButton>
            </div>
          )}
          {tabIdx === 1 && (
            <div style={{ margin: "1em 1.5em" }}>
              <TextField
                select
                className={classes.textField}
                value={period}
                onChange={e => setPeriod(e.target.value)}
                SelectProps={{
                  MenuProps: {
                    className: classes.menu
                  }
                }}>
                {choicesPeriod.map((p, idx) => (
                  <MenuItem key={idx} value={p.id}>
                    {p.name}
                  </MenuItem>
                ))}
              </TextField>
            </div>
          )}
        </div>
      </div>

      {/** Content */}
      <div className={classes.content}>
        <ScheduledTaskRealtime tabIdx={tabIdx} />
        <ScheduledTaskHistory tabIdx={tabIdx} period={period} />
      </div>
    </div>
  );
};

export default ScheduledTask;
